import React from "react";
import CustomTypography from "../../../../../widgets/typography";
import { ContentHeaderProps } from "../types";

export default function ContentHeaderTitle({
  title,
}: ContentHeaderProps): React.JSX.Element {
  return <CustomTypography variant="h3">{title}</CustomTypography>;
}
